var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('page-template',{ref:"returnTemplate",attrs:{"tableOptions":_vm.tableOptions,"searchOptions":_vm.searchOptions,"toolConfig":_vm.toolConfig,"detailColumns":_vm.detailColumns},on:{"searchReset":_vm.searchReset}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d9c8e0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/purchase/Return.vue
// module id = null
// module chunks = 